/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PackageCreateRequest } from '../../models/package-create-request';
import { PackageCreateResponse } from '../../models/package-create-response';

export interface CreatePackage$Params {
      body: PackageCreateRequest
}

export function createPackage(http: HttpClient, rootUrl: string, params: CreatePackage$Params, context?: HttpContext): Observable<StrictHttpResponse<PackageCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, createPackage.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PackageCreateResponse>;
    })
  );
}

createPackage.PATH = '/packages';
